/**
 * What this product is CALLED, and the mark that goes with it.
 *
 * ⚠⚠ TWO DIFFERENT NAMES, and confusing them puts the wrong word on the screen:
 *
 *   PRODUCT_LINE  "Beta"              WHICH product the customer bought. This is what a
 *                                     signed-in person sees at the top of the screen: they
 *                                     know who they bought from, what they need to know is
 *                                     which of our products they are looking at.
 *   VENDOR        "T One Solutions"   WHO they bought it from. Only ever used where the
 *                                     sentence is genuinely about us — support coming into
 *                                     their company, or an error telling them where to go.
 *
 * The app called itself "Fit-Out Manager" everywhere until 2026-09-08. That was the name of
 * the build made for one contractor, and it is not what the product is sold as: the public
 * site sells Alpha, Beta, Gamma and Delta, and a prospect who is shown /beta and then signs
 * in to something with a different name on it reasonably wonders what they were just shown.
 * Alpha made the same change first — see `shared/brand.js` there, which carries the same two
 * names for the same reason.
 *
 * ⚠ The mark is the Greek letter, and the paths below are COPIED FROM THE PUBLIC SITE
 * (`site/public/products.html`, the `pmark` on the Beta card) rather than redrawn. Stroke 2.6,
 * square caps, on a 24 grid — the house rule for all four marks. Redrawing it by eye is how
 * the app and the page it was sold on end up almost matching.
 */
export const PRODUCT_LINE = 'Beta';
export const VENDOR = 'T One Solutions';

/**
 * The Β mark.
 *
 * ⚠ Not drawn through the icon helper in `Home.tsx`: that renders everything at stroke 1.75
 * with round caps, which is right for the navigation icons beside it and wrong for this. The
 * mark has its own weight and it is not ours to soften.
 */
export function BrandMark({ size = 20 }: { size?: number }): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth="2.6"
      strokeLinecap="square"
      focusable="false"
      aria-hidden="true"
    >
      <path d="M6.6 3.8 V20.4" />
      <path d="M6.6 3.8 H14.6 V11.1 H6.6" />
      <path d="M6.6 11.1 H16.6 V20.4 H6.6" />
    </svg>
  );
}
